































import ContingentResult from "@/types/responses/contingent-result";
import { formatCurrency } from "@/utils";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "ContingentTable",
  props: {
    contingent: {
      type: Object as PropType<ContingentResult>,
      required: true,
    },
  },
  computed: {
    sum() {
      return this.contingent.totalContingent;
    },
  },
  methods: {
    convertToCurrency(num: number): string {
      return formatCurrency(num);
    },
  },
});
